import { money } from './fields';
import { formatDate } from '../../service/dateFormatting';

export default function OrderSummary({ order }) {
    return (
        <>
            <h3>Order details</h3>
            <dl className="po-details">
                <dt>Organization</dt>
                <dd>{order.organizationName}</dd>
                <dt>Access confirmation to</dt>
                <dd>{`${order.customerName} — ${order.customerEmail}`}</dd>
                <dt>Invoice to</dt>
                <dd>{order.billingEmail}</dd>
                <dt>Product / amount</dt>
                <dd>{`${order.product} — ${money(order.amountCents)}`}</dd>
                <dt>Invoice</dt>
                <dd>{order.invoiceNumber}</dd>
                <dt>Payment status</dt>
                <dd>
                    {order.paymentStatus === 'paid' ? 'Paid in full' : 'Awaiting payment'}
                </dd>
                <dt>Access code</dt>
                <dd><code>{order.accessCode}</code></dd>
                <dt>Code expires</dt>
                <dd>{formatDate(order.expiresAt)}</dd>
                <dt>Notes</dt>
                <dd>{order.notes || '—'}</dd>
            </dl>
        </>
    );
}
